import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDocument } from "../../hooks/useDocument";
import { useFirestore } from "../../hooks/useFirestore";
import { useAuthContext } from "../../hooks/useAuthContext";
import { useIsAdmin } from "../../hooks/useIsAdmin";

export default function DettaglioDoc() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuthContext();
  const admin = useIsAdmin(user);
  const { document: documento, error } = useDocument("documenti", id);
  const { updateDocument, deleteDocument } = useFirestore("documenti");
  
  // Stati per la modifica
  const [isEditing, setIsEditing] = useState(false);
  const [nomeModificato, setNomeModificato] = useState("");
  
  // Inizializza i valori quando il documento è caricato
  useEffect(() => {
    if (documento) {
      setNomeModificato(documento.nome || "");
    }
  }, [documento]);
  
  const handleEdit = () => {
    setIsEditing(true);
    setNomeModificato(documento.nome || "");
  };
  
  const handleSave = async () => {
    const updates = {
      nome: nomeModificato,
    };
    
    await updateDocument(documento.id, updates);
    setIsEditing(false);
  };
  
  const handleDelete = () => {
    deleteDocument(documento.id);
    // Reindirizza alla pagina dei documenti dopo l'eliminazione
    navigate("/documenti");
  };
  
  if (error) {
    return <div className="error">{error}</div>;
  }
  if (!documento) {
    return <div className="loading">Caricamento in corso</div>;
  }
  
  return (
    <div className="documento-box">
      <div className="documento-dettagli">
        {isEditing ? (
          <h2>
            <input
              type="text"
              value={nomeModificato}
              onChange={(e) => setNomeModificato(e.target.value)}
              className="edit-input"
              style={{ fontSize: "1.5em", fontWeight: "bold", width: "100%" }}
            />
          </h2>
        ) : (
          <h2>{documento.nome}</h2>
        )}
        
        {/* Qui andranno gli altri dettagli del documento */}
        
        {(user.uid === documento.autore?.id || admin) && (
          <>
            {!isEditing ? (
              <>
                <button className="btn" onClick={handleDelete}>
                  Elimina Documento
                </button>
                {admin && (
                  <button className="btn" onClick={handleEdit}>
                    Modifica Documento
                  </button>
                )}
                {/* Pulsante per scaricare il documento */}
                {documento.fileUrl && (
                  <a
                    href={documento.fileUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn"
                    download={documento.nome}
                  >
                    Scarica Documento
                  </a>
                )}
              </>
            ) : (
              <>
                <button className="btn" onClick={handleSave}>
                  Salva Modifiche
                </button>
                <button className="btn" onClick={() => setIsEditing(false)}>
                  Annulla
                </button>
              </>
            )}
          </>
        )}
      </div>
      {documento.fileUrl && (
        <div className="documento-preview">
          {/* Se è un'immagine, mostrala */}
          {documento.fileUrl.match(/\.(jpeg|jpg|gif|png)$/i) && (
            <img src={documento.fileUrl} alt="anteprima documento" />
          )}
          {/* Per altri tipi di file, mostra un'icona o un messaggio */}
          {!documento.fileUrl.match(/\.(jpeg|jpg|gif|png)$/i) && (
            <div className="file-icon">
              <p>Anteprima non disponibile</p>
              <p>Clicca su "Scarica Documento" per visualizzare</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
